import dynamic from "next/dynamic";
import { mileageMock } from "./config";
import classes from "./report-mileage.module.scss";

const Chart = dynamic(() => import("@shared/ui/custom-line-chart/custom-line-chart"), {
    ssr: false
});

export const ReportMileage = () => {
    return (
        <div className={classes.mileage}>
            <div className={classes.mileage__title}>Пробег, тыс. км</div>
            <Chart chartData={mileageMock} />
        </div>
    );
};